import { render, staticRenderFns } from "./BaseLoadingBox.vue?vue&type=template&id=095003ac&scoped=true&"
import script from "./BaseLoadingBox.vue?vue&type=script&lang=js&"
export * from "./BaseLoadingBox.vue?vue&type=script&lang=js&"
import style0 from "./BaseLoadingBox.vue?vue&type=style&index=0&id=095003ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095003ac",
  null
  
)

export default component.exports